import { styled } from 'styled-components'
import colors from '@web-ui-kit/colors'
import { getDevices } from '@web-ui-kit/hooks.use-media-query'

const { LARGE, SMALL } = getDevices()

export const Container = styled.footer`
  align-items: center;
  background-color: ${colors.WHITE};
  border-top: 1px solid ${colors.NEUTRAL_300};
  bottom: 0;
  box-sizing: border-box;
  display: flex;
  grid-area: footer;
  justify-content: center;
  height: 5.5625rem;
  padding: 1rem;
  position: sticky;
  z-index: 1;
  @media (${SMALL}) {
    bottom: 3.5rem;
  }
  @media (${LARGE}) {
    bottom: 0;
  }
`
